import type { CombinedError } from "urql";

/**
 * 画面に出せる形のエラーメッセージを取り出す。
 *
 * urql の `CombinedError.message` は `[GraphQL] ` や `[Network] ` の接頭辞が付いた
 * デバッグ向けの文字列なので、そのまま出すと利用者に内部の用語が見えてしまう。
 * サーバーが返した本文だけを使い、取れない場合は呼び出し側の既定文言に委ねる。
 */
export function toUserFacingMessage(
  error: CombinedError | undefined,
  fallbackMessage: string,
): string {
  const graphQLErrorMessage = error?.graphQLErrors?.[0]?.message;
  if (graphQLErrorMessage) return graphQLErrorMessage;
  if (error?.networkError) return fallbackMessage;
  return error?.message ?? fallbackMessage;
}
